import { render, staticRenderFns } from "./CadastroModalidade.vue?vue&type=template&id=1065bbe0"
import script from "./CadastroModalidade.vue?vue&type=script&lang=js"
export * from "./CadastroModalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports